import { Component } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { NgbActiveModal, NgbDate, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import { Nilable } from "@shared/utils";

@Component({
    selector: "app-modal-date",
    templateUrl: "./modal-date.component.html",
    styleUrls: ["./modal-date.component.scss"]
})
export class ModalDateComponent {
    public mensaje = "";
    public fechaControl = new UntypedFormControl();
    public horaControl = new UntypedFormControl();
    public autodisableControl = new UntypedFormControl();

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar() {
        this.activeModal.dismiss();
    }

    public cargarFecha(fecha: Nilable<Date>) {
        const fechaCargar = fecha ?? new Date();
        this.fechaControl.setValue(
            new NgbDate(fechaCargar.getFullYear(), fechaCargar.getMonth() + 1, fechaCargar.getDate())
        );
        this.horaControl.setValue({
            hour: fechaCargar.getHours(),
            minute: fechaCargar.getMinutes() % 30,
            second: 0
        });
    }

    public cargarBoolean(disable: Nilable<boolean>) {
        const autodisable = disable ?? false;
        this.autodisableControl.setValue(autodisable);
    }

    public enviar() {
        const fecha: NgbDate = this.fechaControl.value;
        const hora: NgbTimeStruct = this.horaControl.value;
        const disable: boolean = this.autodisableControl.value;
        this.activeModal.close(
            [new Date(fecha.year, fecha.month - 1, fecha.day, hora.hour,
                hora.minute), disable]
        );
    }
}
